import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { useWriterComponentState } from "hooks";

import { ClientAppEvent } from "../../../../constants";
import { ErrorTypography } from "../../../ErrorTypography/ErrorTypography";

import type { CompanyBasicDetails } from "components/CompanySetup/types";

interface SendJoinRequestDialogProps {
  company: CompanyBasicDetails;
  isOpen: boolean;
  onClose: () => void;
  onJoinRequestSent: () => void;
  isResubmissionAfterRejection: boolean;
}
export function SendJoinRequestDialog(props: SendJoinRequestDialogProps) {
  const {
    company,
    isOpen,
    onClose,
    onJoinRequestSent,
    isResubmissionAfterRejection,
  } = props;
  const posthog = usePostHog();

  const { loading, write, error, success } = useWriterComponentState({
    errorMessage:
      "Failed to send join request. Please contact us if the issue persists.",
    writeConfig: {
      method: "post",
      url: "/join-company-requests",
      body: {
        company_id: company.id,
      },
    },
    errorMessageKey: "message",
  });

  const handleSubmit = () => {
    write(() => {
      posthog?.capture(ClientAppEvent.JOIN_COMPANY_REQUEST_SENT, {
        company_id: company.id,
        is_resubmission_after_rejection: isResubmissionAfterRejection,
      });
      onClose();
      onJoinRequestSent();
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Join Company?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="body1" gutterBottom>
            Are you sure you want to join <b>{company.name}</b>? The
            administrator will be notified of your request.
          </Typography>
        </DialogContentText>
        <ErrorTypography error={error} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={loading || success} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
